import { TProps } from './types/TProps';

const disabledClassName = ['pointer-events-none', '[&_.icon]:!text-[var(--color-form-field-disabled-icon)]'].join(' ');

export const FormFieldDisabledGroup = ({ disabled = false, className, children }: TProps) => (
  <div className={[disabled ? disabledClassName : '', className].filter(Boolean).join(' ') || undefined}>
    {children}
  </div>
);
